module.exports = __webpack_public_path__ + "img/follow-the-rules-bg.1bb3db1e.svg";